import { useQuery, useMutation, useQueryClient } from "react-query";
import { useNavigate } from "react-router-dom";
import { doc, getDoc, Timestamp } from "firebase/firestore";
import { db } from "../services/firebase";
import { createOpinion, updateOpinion } from "../services/api";
import { OpinionFormData, Opinion } from "../types";

// Firestore直接取得
export const fetchTopicById = async (id: string): Promise<Opinion> => {
  const docRef = doc(db, "topics", id);
  const docSnap = await getDoc(docRef);

  if (!docSnap.exists()) {
    throw new Error("Opinion not found");
  }

  const data = docSnap.data();
  const createdAt = data.createdAt as Timestamp | null;
  const updatedAt = data.updatedAt as Timestamp | null;

  return {
    id: docSnap.id,
    ...data,
    createdAt: createdAt?.toDate?.().toISOString() || null,
    updatedAt: updatedAt?.toDate?.().toISOString() || null,
  } as Opinion;
};

// 問題詳細取得用カスタムフック
export const useTopicById = (id?: string) => {
  return useQuery(["topic", id], () => fetchTopicById(id!), {
    enabled: !!id,
    staleTime: 60000,
  });
};

// 問題作成用カスタムフック
export const useCreateTopic = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  return useMutation(createOpinion, {
    onSuccess: () => {
      // 作成成功後に一覧画面に戻り、キャッシュを更新
      queryClient.invalidateQueries("topics");
      queryClient.invalidateQueries("topicStats"); // 統計も更新
      navigate("/opinions");
    },
  });
};

// 問題更新用カスタムフック
export const useUpdateTopic = (id?: string) => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  return useMutation((data: Partial<OpinionFormData>) => updateOpinion(id!, data), {
    onSuccess: () => {
      // 更新成功後にキャッシュを更新
      queryClient.invalidateQueries(["topic", id]);
      queryClient.invalidateQueries("topics");
      queryClient.invalidateQueries("topicStats"); // 統計も更新
      navigate("/opinions");
    },
  });
};
